const _excluded = ["withPageLoader", "mutationName", "biCode", "toasts"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { useMutation } from '@tanstack/react-query';
import { useOverlayContext } from 'seagull';
import { useStoreActions } from "../../contexts";
import { pathgen } from 'object-path-generator';
export const useArchiveDraftTestIds = pathgen('useArchiveDraftTestIds');
const MutationName = 'useMutationState';
export const useMutationStateTestIds = pathgen('useMutationStateTestIds');
export const useMutationState = options => {
  const {
      withPageLoader,
      mutationName,
      biCode,
      toasts
    } = options,
    rest = _objectWithoutProperties(options, _excluded);
  const {
    startLoader,
    stopLoader,
    showSuccessToast,
    showErrorToast
  } = useOverlayContext();
  const {
    logBI
  } = useStoreActions();
  const mutation = useMutation(_objectSpread(_objectSpread({}, rest), {}, {
    onMutate: function onMutate() {
      var _options$onMutate;
      if (withPageLoader) {
        startLoader(mutationName !== null && mutationName !== void 0 ? mutationName : MutationName);
      }
      if (biCode) {
        logBI(biCode);
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      (_options$onMutate = options.onMutate) === null || _options$onMutate === void 0 || _options$onMutate.call(options, ...args);
    },
    onSettled: function onSettled() {
      var _options$onSettled;
      if (withPageLoader) {
        stopLoader(mutationName !== null && mutationName !== void 0 ? mutationName : MutationName);
      }
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      (_options$onSettled = options.onSettled) === null || _options$onSettled === void 0 || _options$onSettled.call(options, ...args);
    },
    onSuccess: function onSuccess() {
      var _options$onSuccess;
      if (toasts !== null && toasts !== void 0 && toasts.successMessage) {
        var _toasts$successTestId;
        showSuccessToast(toasts.successMessage, (_toasts$successTestId = toasts.successTestId) !== null && _toasts$successTestId !== void 0 ? _toasts$successTestId : useMutationStateTestIds.SuccessToast());
      }
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      (_options$onSuccess = options.onSuccess) === null || _options$onSuccess === void 0 || _options$onSuccess.call(options, ...args);
    },
    onError: function onError() {
      var _options$onError;
      if (toasts !== null && toasts !== void 0 && toasts.errorMessage) {
        var _toasts$errorTestId;
        showErrorToast(toasts.errorMessage, (_toasts$errorTestId = toasts.errorTestId) !== null && _toasts$errorTestId !== void 0 ? _toasts$errorTestId : useMutationStateTestIds.ErrorToast());
      }
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      (_options$onError = options.onError) === null || _options$onError === void 0 || _options$onError.call(options, ...args);
    }
  }));
  return mutation;
};